// extracted by mini-css-extract-plugin
export default {"meal":"MealItem_meal__3fbXO","description":"MealItem_description__+3l1P","price":"MealItem_price__93GNE"};